import Swiper from "swiper/bundle";

var homeSlider;

function createhomeSlider(tbs) {
    const sw = tbs.querySelector(".swiper");
    const paginationEl = sw.querySelector(".home-slider-pagination");

    homeSlider = new Swiper(sw, {
        slidesPerView: 1,
        speed: 600,
        
        
        
        pagination: {
            el: paginationEl,
            clickable: true,
            renderBullet: function (index, className) {
                const number = String(index + 1).padStart(2, '0');
                return `<div class="${className}">
                          <span class="bullet-line"></span>
                          <span class="bullet-number">${number}</span>
                        </div>`;
            },
        },

        on: {
            init: function () {
                updateActiveBullet(this);
            },
            slideChange: function () {
                updateActiveBullet(this);
            },
        },
    });

    function updateActiveBullet(swiper) {
        const bullets = paginationEl.querySelectorAll('.swiper-pagination-bullet');
        bullets.forEach((bullet, index) => {
            const line = bullet.querySelector('.bullet-line');
            const number = bullet.querySelector('.bullet-number');
            
            if (index === swiper.activeIndex) {
                line.style.height = '6rem';
                number.style.fontWeight = '700';
            } else {
                line.style.height = '3rem';
                number.style.fontWeight = '400';
            }
        });
    }
}


function inithomeSlider() {

    const homeVar = document.querySelector(".home-slider");
    if (homeVar) {
        createhomeSlider(homeVar)
    }
}
export { inithomeSlider }
